module.exports = __webpack_public_path__ + "img/back.6737af84.png";